import '../../../Dialogs/View/ViewOrderDialog.scss';

import { useTranslation } from 'react-i18next';

import { IncompleteOrders } from '../../Incomplete.functions';
import GeoLocation from './GeoLocation';

type Props = {
  data: IncompleteOrders | undefined;
};

function ViewIncompleteContentDialog({ data }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <h4>{t('Incomplete Address')}</h4>
      <table cellPadding="0" cellSpacing="0">
        <tbody>
          <tr>
            <td>
              <b>{t('City')}</b>
            </td>
            <td>{data?.address?.cityName ?? '-'}</td>
          </tr>
          <tr>
            <td>
              <b>{t('Municipality')}</b>
            </td>
            <td>{data?.address?.municipalityName ?? '-'}</td>
          </tr>

          <tr>
            <td>
              <b>{t('Place')}</b>
            </td>
            <td>{data?.address?.placeName ?? '-'}</td>
          </tr>
          <tr>
            <td>
              <b>{t('Street')}</b>
            </td>
            <td>{data?.address?.streetName ?? '-'}</td>
          </tr>
          <tr>
            <td>
              <b>{t('House number')}</b>
            </td>
            <td>{data?.address?.housenumber ?? '-'}</td>
          </tr>
          <tr>
            <td>
              <b>{t('Entrance')}</b>
            </td>
            <td>{data?.address?.entrance ?? '-'}</td>
          </tr>
          <tr>
            <td>
              <b>{t('Apartment')}</b>
            </td>
            <td>{data?.address?.apartment ?? '-'}</td>
          </tr>
          <tr>
            <td>
              <b>{t('Post Code')}</b>
            </td>
            <td>{data?.address?.postcode ?? '-'}</td>
          </tr>
          <tr>
            <td>
              <b>{t('Raw address')}</b>
            </td>
            <td>{data?.address?.rawName ?? '-'}</td>
          </tr>
          <tr>
            <td>
              <b>{t('Status')}</b>
            </td>
            <td>{data?.status ?? '-'}</td>
          </tr>
        </tbody>
      </table>

      {data?.resolvedAddress && (
        <>
          <h4>{t('Resolved address')}</h4>
          <table cellPadding="0" cellSpacing="0">
            <tbody>
              <tr>
                <td>
                  <b>{t('City')}</b>
                </td>
                <td>{data?.resolvedAddress?.cityName ?? '-'}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Municipality')}</b>
                </td>
                <td>{data?.resolvedAddress?.municipalityName ?? '-'}</td>
              </tr>

              <tr>
                <td>
                  <b>{t('Place')}</b>
                </td>
                <td>{data?.resolvedAddress?.placeName ?? '-'}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Street')}</b>
                </td>
                <td>{data?.resolvedAddress?.streetName ?? '-'}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('House number')}</b>
                </td>
                <td>{data?.resolvedAddress?.housenumber ?? '-'}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Entrance')}</b>
                </td>
                <td>{data?.resolvedAddress?.entrance ?? '-'}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Apartment')}</b>
                </td>
                <td>{data?.resolvedAddress?.apartment ?? '-'}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Post Code')}</b>
                </td>
                <td>{data?.resolvedAddress?.postcode ?? '-'}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Raw address')}</b>
                </td>
                <td>{data?.resolvedAddress?.rawName ?? '-'}</td>
              </tr>
            </tbody>
          </table>
          <b>{t('Location')}</b>
          <GeoLocation data={data} />
        </>
      )}
    </>
  );
}

export default ViewIncompleteContentDialog;
